import { TDR } from 'tdr-common';

export const applyGroupSizeFilter = (tables: TDR.Table[], groupSize: number) => {
	return tables.filter(
		(table) => table.minGuests <= groupSize && table.maxGuests >= groupSize
	);
};